/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_DetachedInputs */

const vi_camera_station_detached = /** @type {(inputs: Camera_Station_DetachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gỡ camera khỏi trạm`)
};

/**

* @param {Camera_Station_DetachedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_detached = /** @type {((inputs?: Camera_Station_DetachedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_DetachedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_detached(inputs)
});